export const common = () => {
  $(document).ready(function () {
    $("select").niceSelect();
  });
  const stickyButton = () => {
    const windowHeight = window.innerHeight;
    const modals = document.querySelectorAll(".contact-us-popup");
    modals.forEach((modal) => {
      let modalHeight;
      const fixedButton = modal.querySelector(".contact-us-form-submit");
      if (modal.classList.contains("contact-us-popup-jobs")) {
        modalHeight = 0;
      } else {
        modalHeight = 1110;
        if (modalHeight < windowHeight) {
          fixedButton.classList.remove("fixed-submit");
          modal.classList.add("withoutmargin");
        } else {
          fixedButton.classList.add("fixed-submit");
          modal.classList.remove("withoutmargin");
        }
      }
    });
  };

  stickyButton();
  window.addEventListener("scroll", stickyButton);
  window.addEventListener("resize", stickyButton);

  // start mobile form resize
  const adjustFormHeight = (formSelector, formSubmitSelector, offsetHeight) => {
    if (window.matchMedia("(max-width: 767px)").matches) {
      const formSubmit = document.querySelector(formSubmitSelector);
      const commentFormWrapper = document.querySelector(formSelector);
      if (formSubmit && commentFormWrapper) {
        const windowHeight = window.innerHeight;
        const formSubmitHeight = formSubmit.offsetHeight + offsetHeight;
        const availableHeight = windowHeight - formSubmitHeight;
        commentFormWrapper.style.height = `${availableHeight}px`;
      }
    }
  };
  const commentFormWrapper = document.querySelector(".contact-us-form-mobile");
  const formSubmit = document.querySelector(".contact-us-form-submit");
  if (commentFormWrapper && formSubmit && window.innerWidth < 768) {
    adjustFormHeight(".contact-us-form-mobile", "contact-us-form-submit", 150);
    window.addEventListener("load", () => {
      adjustFormHeight(".contact-us-form-mobile", ".contact-us-form-submit", 150);
    });
    window.addEventListener("resize", () => {
      adjustFormHeight(".contact-us-form-mobile", ".contact-us-form-submit", 150);
    });
  }

  function setupModal(modalButtonSelector, modalBackdropSelector, closeButtonSelector, wrapperClass, thanksClass, containerClass) {
    const modalButtons = document.querySelectorAll(modalButtonSelector);
    if (modalButtons) {
      modalButtons.forEach((modalButton) => {
        const modal = document.querySelector(modalBackdropSelector);
        const closeButton = document.querySelector(closeButtonSelector);
        const html = document.querySelector("html");
        const body = document.querySelector("body");
        const closeModal = () => {
          modal.classList.add("is-hidden");
          body.classList.remove("overflow-hidden");
          html.classList.remove("overflow-hidden");
        };
        const clickOutsideModal = (e) => {
          const target = e.target;
          if (!target.closest(containerClass)) {
            closeModal();
          }
        };
        modalButton.addEventListener("click", (e) => {
          e.preventDefault();
          modal.classList.remove("is-hidden");
          body.classList.add("overflow-hidden");
          html.classList.add("overflow-hidden");
          modal.addEventListener("click", clickOutsideModal);
          if (closeButton) {
            closeButton.addEventListener("click", closeModal);
          }
        });
      });
    }
  }
  setupModal(".pink-button-mobile", ".backdrop", ".close-popup", null, null, ".contact-us-popup-jobs");
};
